import { IDatasource } from 'utility-ts-orm';
import { PathTask } from './../builders/path_task_builder';

export class PathTaskUpdateService {
  constructor(
    private ngPathTaskDatastore: IDatasource<PathTask>,
    private ngOverduePathTaskDatastore: IDatasource<PathTask>,
    private TaskStatusEnum: any
  ) {}

  updatePathTask(task: PathTask, taskUpdate: PathTask): void {
    if (this.ngOverduePathTaskDatastore.contains([{ ...task, ...taskUpdate }])) {
      this.ngOverduePathTaskDatastore.put(taskUpdate);
      this.updatePathTaskDataSource(task, taskUpdate);
    } else {
      this.ngPathTaskDatastore.put(taskUpdate);
    }
  }

  private updatePathTaskDataSource(task: PathTask, taskUpdate: PathTask): void {
    if (this.TaskStatusEnum.isActive(taskUpdate.status)) {
      this.ngPathTaskDatastore.del({ ...task, ...taskUpdate });
    } else {
      this.ngPathTaskDatastore.put({ ...task, ...taskUpdate });
    }
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/services/path_task_update_service.ts